const locale = {
    ctm: 'CTM',
    ctm_tft: 'TFT',
    ctm_a_measurement: 'A Measurement',
	face_photo:'Face Photo',
    scanner:'Scanner',
    assessment:'Assessment',
    street_view:'Street View',
    tunnel_remote_view:'Tunnel Remote View',
    tunnel_face_assessment_system :'Tunnel Face Assessment System',
    face_camera:'Face Camera',
    a_measurement:'A Measurement',
    b_measurement:'B Measurement',
    tft:'TFT',
    step_mgmt:'Step Management',
    process_simulator:'PCMS',
    no_data_project: 'You have selected {{projectName}}. This project dont have any data related to CTM',
    DM: '{{categoryCode}} ({{date}})',
    LHF: '下半部の切羽 ({{date}})',
    UHF: '上半部の切羽 ({{date}})',
    lining: '覆工 ({{date}})',
    cross_section_name:'Cross-section name',
    measurement_positions:'Measurement Positions',
    construction_project_name:'Construction project name',
    drawing_name:'Drawing name',
    date_of_creation:'Date creation',
    station_name:'Station name',
    constructor:'Constructor',
    client:'Client',
    page_number: 'Page {{pageNumber}} of {{numPages}}',
    name:'Name',
    number:'番号',
    face_line:'切羽線名称',
    upphlf:'upphlf',
    lowhf:'lowhf',
    invertMeas:'Invert',
    x_axis_title:'Total number of days',
    safety_threshold:'Safety threshold',
    title_y_axis: '内空変位・沈下量(mm)',
    title_y2_axis:'切羽離れ(m)',
    title_page:"aMeasurement | SCAI",
    title_page_landing:"CTM | SCAI",
    title_page_tft:"TFT | SCAI",
    lower_half_face:'Lower half face',
    lining_concrete:'Lining concrete',
    invert:'Invert',
    upper_half_face:'Upper Half Face',
    pit_side:'Mouth',
    arrival_side:'Destin.',
    min_max: 'Min/Max',
    value: 'Value',
    update_y_axis:'Update Y Axis',
    y_axis:'Y Axis',
    update_x_axis:'Update X Axis',
    x_axis:'X Axis',
    threshold: 'Threshold',
    print:'Print',
    interval_y_axis:'Interval Y Axis',
    interval_y2_axis:'Interval Y2 Axis',
    settleTop: '天端',
    settleUpLeft: '左上',
    settleUpRight: '右上',
    settleLowLeft: '左下',
    settleLowRight: '右下',
    start_date: 'Start Date',
    number_days: 'Number of Days',
    max: 'max',
    min: 'min',
    scale_interval: 'interval',
    loading:"Loading",
    downloading_image:'Image downloading...',
    graph_is_being_generated: 'Graph is being generated',
    select_a_project_to_load_CTM_data: 'Select a project to load CTM data',
    tunnel_image:"Tunnel Image",
    search_project: 'Search Project',
    code:'Code:',
    branch: 'Branch:',
    last_update: 'Last update',
    status: 'Status',
    file_name: 'Filename',

    zoomIn: 'Zoom In',
    zoomOut: 'Zoom Out',
    zoomReset: 'Reset',
    
};

export default locale;